import React from 'react'
import { Col, Container, Form, Modal as BootstrapModal, Row } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'
import { Controller, useForm } from 'react-hook-form'
import { FormFeedback } from '../../../components/Form/FormFeedback'

export interface UpdateMeetingTemplatePrivacyModalProps {
  show: boolean
  onConfirm: (changePastMeetings: boolean) => void
  onCancel: () => void
  isPrivate: boolean
}

type UpdateMeetingTemplatePrivacyFormValues = {
  pastMeetingsAction: 'keep' | 'change'
}

const updateMeetingTemplatePrivacyDefaultValues = {
  pastMeetingsAction: 'keep',
}

export const UpdateMeetingTemplatePrivacyModal: React.FC<UpdateMeetingTemplatePrivacyModalProps> = ({ show, onConfirm, onCancel, isPrivate }) => {
  const privacyName = isPrivate ? 'private' : 'public'
  const privacyChangeInfo = isPrivate
    ? "Manually changed meetings won't be affected."
    : "Imported private events and manually changed meetings won't be affected."
  const form = useForm<UpdateMeetingTemplatePrivacyFormValues>({
    defaultValues: updateMeetingTemplatePrivacyDefaultValues as UpdateMeetingTemplatePrivacyFormValues,
  })

  const pageBody = (
    <Container>
      <Row className='m-0'>
        <Col className='p-0'>
          <div className='paragraph-medium mb-3'>
            You're changing the default visibility for this Meeting Type to {privacyName}. Should past meetings also change to {privacyName}?
          </div>
          <Controller
            name='pastMeetingsAction'
            control={form.control}
            render={({ field, fieldState }) => {
              return (
                <>
                  <div>
                    <Form.Check
                      inline
                      type='radio'
                      className='pb-2'
                      label='Keep past meetings as they are'
                      id='keep'
                      {...field}
                      value='keep'
                      checked={field.value === 'keep'}
                    />
                    <Form.Check
                      inline
                      type='radio'
                      label={`Change past meetings to ${privacyName}`}
                      id='change'
                      {...field}
                      value='change'
                      checked={field.value === 'change'}
                    />
                  </div>
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </>
              )
            }}
          />
        </Col>
      </Row>
      <Row className='m-0 py-3'>
        <Col className='p-0'>
          <div className='zocks-bg-color-gray-200 rounded p-3'>
            <div className='d-flex align-self-center gap-3 align-items-center'>
              <i className='bi bi-info-square zocks-text-gray-900 recurring-event-info-square' />
              <span className='paragraph-medium zocks-text-gray-900'>{privacyChangeInfo}</span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      header={<BootstrapModal.Title>Change past meetings</BootstrapModal.Title>}
      body={pageBody}
      show={show}
      onHide={onCancel}
      footerPrimaryActionTitle='Apply'
      showFooterActions={true}
      centered
      onFooterPrimaryAction={() => onConfirm(form.getValues('pastMeetingsAction') === 'change')}
      onFooterSecondaryAction={onCancel}
      headerBodySeparator={true}
    />
  )
}
